(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wayborne-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ws-product]').forEach(root=>{
root.querySelectorAll('[data-ws-image]').forEach(button=>button.addEventListener('click',()=>{
const img=root.querySelector('.ws-main-image');img.removeAttribute('srcset');img.src=button.dataset.wsImage;
root.querySelectorAll('[data-ws-image]').forEach(b=>b.removeAttribute('aria-pressed'));button.setAttribute('aria-pressed','true');
}));
const select=root.querySelector('[data-ws-variant]');
if(select)select.addEventListener('change',()=>{
const option=select.selectedOptions[0],add=root.querySelector('[data-ws-add]');
root.querySelector('[data-ws-price]').textContent=option.dataset.price;
add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;
});
});

  } catch(e) { console.error(e); }
})();
})();
